export const PASSWORD_HASH =
  '96061e92f58e4bdcdee73df36183fe3ac64747c81c26f6c83aada8d2aabb1864';

const bufferToHex = (buffer) =>
  Array.from(new Uint8Array(buffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');

const hashString = async (value) => {
  if (!window.crypto || !window.crypto.subtle) {
    throw new Error('Web Crypto API not available');
  }

  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  return bufferToHex(hashBuffer);
};

export const verifyPassword = async (input) => {
  if (!input) {
    return false;
  }

  try {
    const hashedInput = await hashString(input.trim());
    return hashedInput === PASSWORD_HASH;
  } catch (error) {
    console.error('Failed to hash password input', error);
    return false;
  }
};

